import { ProductDatingUponReceiptIssueTypeDomestic } from '../../../../enums';

export interface IProductDatingSubtypeDom {
    issueType: ProductDatingUponReceiptIssueTypeDomestic;
}
